// extracted by mini-css-extract-plugin
export default {"root":"DownloadExcel_root__oDVuc","content":"DownloadExcel_content__xzh0Z"};